<ng-container *transloco="let t">
  <main class="cko-callback-component" [class.rtl]="rtlMode$ | async">
    <popsy-lottie-animation
      class="animation"
      animation="popsy-loading"></popsy-lottie-animation>
  </main>
</ng-container>
